<template>
  <list-view-cell class="procurement-cell">
    <div class="flex justify-between w-full">
      <div class="flex-grow">
        <p>{{ name }}</p>
        <p v-if="delivered_at && scheduled_for">
          {{ scheduled_for | moment("hh:mm a") }}
        </p>
        <p v-if="project_name">{{ project_name }}</p>
        <template v-if="customer">
          <p v-if="customer.name">{{ customer.name }}</p>
          <template v-if="customer.places && customer.places.length">
            <p>{{ customer.places[0].address_1 }}</p>
            <p>
              {{ customer.places[0].cityStateZip }}
              <a
                class="ml-1 text-red hover-bold"
                :href="generateGoogleMapsUrl(customer.places[0])"
              >
                <i class="fal fa-map-marker-alt"></i>
              </a>
            </p>
          </template>
        </template>
        <div class="mt-2" v-if="note && note.text">
          <p>
            Note:
            <span>{{ note.text }}</span>
          </p>
        </div>
      </div>
      <div class="flex-shrink-0" v-if="displayTime">
        <p class="text-lg">{{ displayTime | moment("hh:mm a") }}</p>
      </div>
    </div>
  </list-view-cell>
</template>

<script>
import ListViewCell from "../ListViewCell";
import { Contact } from "../../../../models/Contact";

export default {
  name: "ProcurementCell",
  components: { ListViewCell },
  props: {
    name: String,
    scheduled_for: Date,
    delivered_at: Date,
    project_name: String,
    customer: Contact,
    note: Object,
    displayTime: Date
  }
};
</script>

<style scoped></style>
